/*accordion on product page */
$(document).ready(function() {
  //toggle the component with class accordion_body
  $(".accordion_head").click(function() {
    if ($('.accordion_body').is(':visible')) {
      $(".accordion_body").slideUp(300);
      $(".plusminus").text('+');
    }
    if ($(this).next(".accordion_body").is(':visible')) {
      $(this).next(".accordion_body").slideUp(300);
      $(this).children(".plusminus").text('+');
    } else {
      $(this).next(".accordion_body").slideDown(300);
      $(this).children(".plusminus").text('-');
    }
  });
});


/**
 * Include your custom JavaScript here.
 *
 * We also offer some hooks so you can plug your own logic. For instance, if you want to be notified when the variant
 * changes on product page, you can attach a listener to the document:
 *
 * document.addEventListener('variant:changed', function(event) {
 *   var variant = event.detail.variant; // Gives you access to the whole variant details
 * });
 *
 * You can also add a listener whenever a product is added to the cart:
 *
 * document.addEventListener('product:added', function(event) {
 *   var variant = event.detail.variant; // Get the variant that was added
 *   var quantity = event.detail.quantity; // Get the quantity that was added
 * });
 *
 * If you just want to force refresh the mini-cart without adding a specific product, you can trigger the event
 * "cart:refresh" in a similar way (in that case, passing the quantity is not necessary):
 *
 * document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', {
 *   bubbles: true
 * }));
 */

/* Coupon code copy */
function CopyToClipboard (containerid) {
  var btnCopy = document.getElementById( "copy" );
  var main = document.getElementById( "maincontent" );
  // Create a new textarea element and give it id='temp_element'
  var textarea = document.createElement("textarea");
  textarea.id = "temp_element";
  // Optional step to make less noise on the page, if any!
  textarea.style.height = 0;
  // Now append it to your page somewhere, I chose <body>
  document.body.appendChild(textarea);
  // Give our textarea a value of whatever inside the div of id=containerid
  textarea.value = document.getElementById(containerid).innerText;
  // Now copy whatever inside the textarea to clipboard
  var selector = document.querySelector("#temp_element");
  selector.select();
  document.execCommand("copy");
  // Remove the textarea
  document.body.removeChild(textarea); 
  // Add copied text after click
  if ( document.execCommand( "copy" ) ) {
      btnCopy.classList.add( "copied" );
    
      var temp = setInterval( function(){
        btnCopy.classList.remove( "copied" );
        clearInterval(temp);
      }, 600 );
    
  } else {
    console.info( "document.execCommand went wrong…" );
  }
    
}


$(document).ready(function() {
 $(".HorizontalList__Item input[type=radio]").on('change', function(){
   setTimeout(function(){
     
      var variant_weight_val = $('select[name="id"] option:selected').attr("data-weight");
      var variant_sku_val = $('select[name="id"] option:selected').attr("data-sku");
      var variant_title_val = $('select[name="id"] option:selected').text();
      var variant_stock_val = $('select[name="id"] option:selected').attr("data-inventory");
     
     
      $('.variant_selected').html(variant_title_val); 
      $('.variant_sku').html(variant_sku_val); 
      $('.variant_weight').html(variant_weight_val); 
      $('.variant_inventory').html(variant_stock_val); 
     
   }, 2000);
});
  
});
/*

 $(".HorizontalList__Item input[type=radio]").on('change', function(){
   setTimeout(function(){
   var selectTexts = $('select[name="id"] option:selected').attr("data-sku");
  // console.log(selectTexts);
  $('.variant_sku').html(selectTexts);
   }, 2000);
});
  
 $(".HorizontalList__Item input[type=radio]").on('change', function(){
   setTimeout(function(){
   var selectQuantity = $('this + option:selected').attr("current_variant.inventory_quantity");
  $('.variant_inventory').html(selectQuantity);    
   }, 2000);
});  
  
}); 

*/

 // JavaScript for Popup Functionality
  document.getElementById("getQuoteBtnhd").addEventListener("click", function () {
    document.getElementById("quotePopup").style.display = "flex";
  });

  document.getElementById("closePopup").addEventListener("click", function () {
    document.getElementById("quotePopup").style.display = "none";
  });

  // Close popup when clicking outside the content
  document.getElementById("quotePopup").addEventListener("click", function (e) {
    if (e.target === this) {
      this.style.display = "none";
    }
  });

  // Form submission handling
  document.getElementById("quoteForm").addEventListener("submit", function (e) {
    e.preventDefault(); // Prevent default form submission

    const fullName = document.getElementById("fullName").value;
    const email = document.getElementById("email").value;
    const rugDetail = document.getElementById("rugDetail").value;

    console.log("Form Submitted", { fullName, email, rugDetail });

    // Add your AJAX call or Shopify logic here

    alert("Your quote request has been submitted.");
    document.getElementById("quotePopup").style.display = "none";
    document.getElementById("quoteForm").reset();
  });